import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase/firebase";
import { errorTextFieldStyles } from "../../styles/globalStyles";

const ForgotPassword = ({ open, onClose }) => {
  const [email, setEmail] = useState("");
  const [feedback, setFeedback] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    setFeedback("");
    setError("");
    if (!email) {
      setError("Please enter your email address.");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setFeedback(
        "Success! Please check your inbox and spam folder. It may take a few minutes to arrive."
      );
    } catch (err) {
      if (err.code === "auth/user-not-found") {
        setError("No account found with this email. You may need to sign up.");
      } else if (err.code === "auth/invalid-email") {
        setError("Please enter a valid email address.");
      } else {
        setError("An error occurred. Please try again.");
      }
    }
  };

  const handleClose = () => {
    setEmail("");
    setFeedback("");
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} PaperProps={{ sx: { borderRadius: 4, maxWidth: 400, width: "100%"  } }}>
      <DialogTitle>Reset Your Password</DialogTitle>
      <DialogContent>
        <Typography variant="body2" mb={2}>
          Enter your email address and we'll send you a link to reset your password.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          label="Email Address"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          margin="dense"
          required
          error={!!error}
          helperText={error || ""}
          sx={error ? errorTextFieldStyles : {}}
        />
        {feedback && (
          <Typography color="primary" mt={1}>
            {feedback}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} sx={{ textTransform: "none", borderRadius: "25px", px: 3, py: 1.25, left: "-15px", top: "-12px" }}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" sx={{ textTransform: "none", borderRadius: "25px", px: 3, py: 1.25, left: "-15px", top: "-12px" }}>
          Send Reset Email
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ForgotPassword;
